var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"user"},[_c('div',{staticClass:"userIcon"}),_c('span',[_vm._v(_vm._s(_vm.userInfo.name))]),_c('es-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.$t(`退出`),"placement":"top-end"}},[_c('div',{staticClass:"out",on:{"click":_vm.goOut}})])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }